import React, { Fragment } from "react";
import { attachmentSizeLabel } from "utils/attachment";
import { getMimeTypeLabel } from "utils/attachment";

/**
 * Open the asset picker for image upload
 * @param {Object} params
 * @param {Function} params.onClick
 */
const AssetMimetypePrompt = ({ mimetype, prompt, size, filename }) => {
  return (
    <div className="w-100 flex flex-column items-center justify-center tc pa3 bg-white--hover pointer">
      <div className="w-auto center flex flex-column items-center ba hairline-1 br2 pa3">
        <div
          className="bg-black-05 color-text--secondary items-center justify-center flex br2"
          style={{ height: 40, width: 40 }}
        >
          <div className="f6 fw6">{getMimeTypeLabel(mimetype)}</div>
        </div>
        {filename && (
          <Fragment>
            <div className="f6 pt2">{`${attachmentSizeLabel(size)}`}</div>
            <div className="f6 pv3">{filename}</div>
          </Fragment>
        )}
      </div>
      <div className="f7 pv3">{prompt.header}</div>
    </div>
  );
};

export default AssetMimetypePrompt;
